(function ($, lity) {
  'use strict';

  /**
   * Main functionality should be in an 'init' function
   */
  var initArticlesCarousel = function () {
    var $self;
    var $expandCollapse;
    var $slides;
    var tabletBreakpoint = window.matchMedia('(min-width:768px)');
    var largeBreakpoint = window.matchMedia('(min-width:1800px)');
    var mobileBreakpoint = window.matchMedia('(max-width:767px)');
    var mobileTabletBreakpoint = window.matchMedia('(max-width: 1023px)');
    var articlesCarousel;

    $self = $(this);
    $slides = $('.swiper-slide', $self);
    articlesCarousel = new Swiper($self.find('.swiper')[0], {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: 25,
      a11y: true,
      rewind: true,
      preloadImages: true,
      simulateTouch: false,
      allowTouchMove: true,
      slidesOffsetAfter: 25,
      watchSlidesProgress: true,
      navigation: {
        nextEl: '.button-next', $self,
        prevEl: '.button-prev', $self,
      },
      on: {
        beforeResize: function () {
          var columnWidth = $(window).outerWidth() / 48;

          if (mobileBreakpoint.matches) {
            this.params.spaceBetween =  Math.ceil(columnWidth * 4);
            this.params.slidesOffsetAfter = Math.ceil(columnWidth * 8);
          }

          if (tabletBreakpoint.matches) {
            this.params.spaceBetween =  Math.ceil(columnWidth);
            this.params.slidesOffsetAfter = Math.ceil(columnWidth * 5);
          }

          if (largeBreakpoint.matches) {
            columnWidth = 1800 / 48;
            this.params.spaceBetween =  columnWidth;
            this.params.slidesOffsetAfter = columnWidth * 5;
          }
        },
        afterInit: function () {
          $expandCollapse = $('.expand-collapse', $self);

          $expandCollapse.each(function(i, el) {

            $(el).on('click', function (e) {
              e.preventDefault();

              var $currentSlide = $(this).parents('.swiper-slide');

              if ($currentSlide.hasClass('is-expanded')) {
                closeSlide($currentSlide);
              } else {
                openSlide($currentSlide)
              }
            });
          });
        }
      }
    });

    function openSlide(el) {
      var $currentSlide = el;

      closeSlides();

      $slides.css({'min-height':  $currentSlide.outerHeight()});
      $currentSlide.find('.card-inner').css('min-height', $currentSlide.outerHeight());
      $currentSlide.find('.card-inner').animate({ 'min-height': $currentSlide.outerHeight() + 150 }, 300, function () {
        $currentSlide.find('.read-more').fadeToggle(150);
      });

      $currentSlide.addClass('is-expanded');
      $currentSlide.find('button.expand-collapse').addClass('is-expanded');

    }

    function closeSlide(el) {
      var $currentSlide = el;

      $currentSlide.find('.read-more').fadeToggle(150);

      $currentSlide.find('.card-inner').animate({'min-height': $currentSlide.outerHeight()}, 300, function () {
        $slides.css({'min-height':  ''});
        $currentSlide.find('.card-inner').css({'min-height': ''});
        $currentSlide.removeClass('is-expanded');
        $currentSlide.find('button.expand-collapse').removeClass('is-expanded');
      });

    }

    function closeSlides () {
      $slides.each(function (i, el) {
        if ($(el).hasClass('is-expanded')) {
          closeSlide($(el));
        }
      });
    }

    $(window).on('resize', function () {
      if (mobileTabletBreakpoint.matches) {
        closeSlides();
      }
    });
  };

  /**
   * This is boilerplate: add a behavior to window.DP.behaviors
   */
  window.DP.behaviors.articlesCarousel = {
    attach: function (context) {
      $(context).find('.cc--articles-carousel').once('articlesCarousel').each(function () {
        initArticlesCarousel.apply(this);
      });
    }
  };

}(jQuery, lity));
